import React, { FC, useCallback, useContext } from 'react';
import styles from './favorites.module.scss';
import Dialog from '@smart-tv/components/dialog';
import DialogContent from '@smart-tv/components/dialog/dialog-content';
import FeedbackDialog from '@smart-tv/components/feedback-dialog';
import useEventListener from '@smart-tv/hooks/use-event-listener';
import FavoritesEditContext from '@smart-tv/contexts/favorites-edit-context';

import FavoritesHomeScreen from './favorites-home/favorites-home';
import FavoritesEditScreen from './favorites-edit/favorites-edit';
import FavoritesTitleScreen from './favorites-title';
import FavoritesSaveScreen from './favorites-save';
import FavoritesDeleteScreen from './favorites-delete';
import { FavoritesScreen } from '@smart-tv/contexts/favorites-edit-context/favorites-edit-context';
import useNetwork from '@smart-tv/hooks/use-network/use-network';
import { isBackKey } from '@smart-tv/utils/remoteKeys';

const screenMapper = {
  HOME: FavoritesHomeScreen,
  EDIT: FavoritesEditScreen,
  TITLE: FavoritesTitleScreen,
  SAVE: FavoritesSaveScreen,
  DELETE: FavoritesDeleteScreen
};

export const Favorites: FC = () => {
  const {
    open,
    selectedScreen,
    openFeedbackDialog,
    handleCloseFeedbackDialog,
    handleClose,
    handleSelectScreen,
    handleBackNavigation
  } = useContext(FavoritesEditContext);

  const { isOffline } = useNetwork();

  const FavoritesSelectedScreen = screenMapper[selectedScreen];
  const isRenaming = selectedScreen === FavoritesScreen.Title;
  const isEditScreenMounted = selectedScreen === FavoritesScreen.Edit || isRenaming;

  const handleKeyPress = useCallback(() => {
    switch (selectedScreen) {
      case FavoritesScreen.Home:
        handleClose();
        break;
      case FavoritesScreen.Edit:
        handleBackNavigation();
        break;
      case FavoritesScreen.Delete:
        handleSelectScreen(FavoritesScreen.Home);
        break;
      case FavoritesScreen.Save:
      case FavoritesScreen.Title:
        handleSelectScreen(FavoritesScreen.Edit);
        break;
    }
  }, [handleClose, handleSelectScreen, selectedScreen, handleBackNavigation]);

  useEventListener('keydown', (event: KeyboardEvent) =>
    isBackKey(event) && !isOffline ? handleKeyPress() : undefined
  );

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={handleKeyPress}
      showCloseButton={false}
      disableEscapeKeyDown={true}
      dialogContainerProps={{ className: styles['favorites-dialog-container'] }}
    >
      <DialogContent>
        <div className={styles['favorites']}>
          {isEditScreenMounted && <FavoritesEditScreen isHidden={isRenaming} />}
          {selectedScreen !== FavoritesScreen.Edit && <FavoritesSelectedScreen />}
          <FeedbackDialog
            message="Listen blev gemt"
            open={openFeedbackDialog}
            onClose={handleCloseFeedbackDialog}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Favorites;
